// Action types
export const MEDICATIONS_ACTION_TYPES = {
  SET_DRUG_STATUS: 'SET_DRUG_STATUS',
  SET_SELECTED_MEDICATION_ID: 'SET_SELECTED_MEDICATION_ID',
  SET_SORT_BY: 'SET_SORT_BY',
  SET_EXPANDED_SECTION: 'SET_EXPANDED_SECTION',
  SET_PRESCRIBED_RX_ENABLED: 'SET_PRESCRIBED_RX_ENABLED',
  RESET_MEDICATIONS_FILTERS: 'RESET_MEDICATIONS_FILTERS',
  SET_DEFAULT_MEDICATIONS_FILTERS: 'SET_DEFAULT_MEDICATIONS_FILTERS',
};

// Action creators
export const setDrugStatus = (status) => ({
  type: MEDICATIONS_ACTION_TYPES.SET_DRUG_STATUS,
  payload: status,
});

export const setSelectedMedicationId = (medicationId) => ({
  type: MEDICATIONS_ACTION_TYPES.SET_SELECTED_MEDICATION_ID,
  payload: medicationId,
});

export const setSortBy = (sortBy) => ({
  type: MEDICATIONS_ACTION_TYPES.SET_SORT_BY,
  payload: sortBy,
});

export const setExpandedSection = (expandedSection) => ({
  type: MEDICATIONS_ACTION_TYPES.SET_EXPANDED_SECTION,
  payload: expandedSection,
});

export const setPrescribedRxEnabled = (enabled) => ({
  type: MEDICATIONS_ACTION_TYPES.SET_PRESCRIBED_RX_ENABLED,
  payload: enabled,
});

export const resetMedicationsFilters = () => ({
  type: MEDICATIONS_ACTION_TYPES.RESET_MEDICATIONS_FILTERS,
});

export const setDefaultMedicationsFilters = () => ({
  type: MEDICATIONS_ACTION_TYPES.SET_DEFAULT_MEDICATIONS_FILTERS,
});
